import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

import { SegmentController } from '@tcc/crate';

// constants
import { scriptTypes } from 'constants/scripts';

const baseString = 'vra-script-type-toggle';
const classString = classNames({
  [`${baseString}`]: true
});
const ScriptTypeToggle = ({
  activeScriptType,
  onSelectScriptType
}) => {
  const options = Object.values(scriptTypes).filter(scriptType => {
    return scriptType !== scriptTypes.EXPERIMENT;
  })
  .map((scriptType) => {
    return {
      id: scriptType,
      value: getMessage(scriptType)
    };
  });

  return (
    <section className={classString}>
      <SegmentController
        className={`${baseString}__controller`}
        handleClick={onSelectScriptType}
        selected={`${activeScriptType}`}
        tabClassName={`${baseString}__tab`}
        tabs={options}
        testId={baseString}
      />
    </section>
  );
};

ScriptTypeToggle.propTypes = {
  activeScriptType: PropTypes.string,
  onSelectScriptType: PropTypes.func
};

export default ScriptTypeToggle;
